import { GridToolbarContainer } from "@mui/x-data-grid";
import ActionButtons from "../ActionUserButtons";
import { API_URL, handleSendMessage, syncItems } from "src/utilities";
import { IAppUserWebSystem } from "src/interface/IAppUserWebSystem";
import { useMutation } from "@tanstack/react-query";
import { IUserInfo } from "src/interface/IUserInfo";
import { useAuth } from "src/context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";

interface EditToolbarWebSystemProps {
  userRef?: string;
  updatingSystems?: IAppUserWebSystem[];
  setUpdatingSystems?: (updatingSystems: IAppUserWebSystem[]) => void;
  existingSystems?: IAppUserWebSystem[];
  onClose: () => void;
  refetchUser: () => void;
}

export function EditToolbarWebSystem({
  userRef,
  updatingSystems,
  existingSystems,
  onClose,
  setUpdatingSystems,
  refetchUser,
}: EditToolbarWebSystemProps) {
  const { user } = useAuth();

  const notifications = useNotifications();
  const { mutateAsync: insertWebSystem, isPending: systemLoading } =
    useMutation({
      mutationFn: async (body: any) => {
        const response = await fetch(API_URL + "appUser-websystem", {
          method: "POST",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
          body: JSON.stringify(body),
        });
        return await response.json();
      },
      onSuccess: (responseData) => {
        JSON.stringify(responseData);
        refetchUser();
        handleSendMessage(
          notifications,
          "تغییرات سامانه ها ذخیره شد!",
          "success"
        );
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const {
    mutateAsync: updateWebSystemAsync,
    isPending: isPendingAppUserSystemEdit,
  } = useMutation({
    mutationFn: async (body: IUserInfo) => {
      const response = await fetch(API_URL + "appUser-websystem/" + body.id, {
        method: "Put",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });

      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
      handleSendMessage(
        notifications,
        "تغییرات سامانه ها ذخیره شد!",
        "success"
      );
      refetchUser();
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: deleteWebSystemAsync,
    isPending: isDeleteAppUserSystemLoading,
  } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "appUser-websystem/" + body.id, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });

      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
      handleSendMessage(
        notifications,
        "تغییرات سامانه ها ذخیره شد!",
        "success"
      );
      refetchUser();
    },
    onError: (error) => {
      notifications.show("خطا در حذف سامانه های کاربر: " + error.message, {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const onSave = async () => {
    // بررسی شرط جدید
    if (
      (existingSystems?.every(
        (row) =>
          (!row.userName || row.userName.trim() === "") &&
          (!row.password || row.password.trim() === "")
      ) ||
        !existingSystems) &&
      updatingSystems?.every(
        (row) =>
          (!row.userName || row.userName.trim() === "") &&
          (!row.password || row.password.trim() === "")
      )
    ) {
      handleSendMessage(
        notifications,
        "هیچ سامانه‌ای با نام کاربری و رمز عبور معتبر برای ذخیره‌سازی وجود ندارد",
        "error",
        3000,
        "error"
      );
      return;
    }
    try {
      await syncItems<IAppUserWebSystem>({
        deleteItemAsync: deleteWebSystemAsync,
        existingItems: existingSystems,
        insertItemAsync: insertWebSystem,
        isEdit: true,
        RefField: "customerRef",
        RefValue: userRef,
        updatedItems: updatingSystems
          ?.filter((f) => f.userName !== "" || f.password !== "")
          ?.map(({ system, ...rest }) => ({
            ...rest,
            id: rest.MainId ?? rest.id,
          })),
        updateItemAsync: updateWebSystemAsync,
      });
    } catch (error) {
      console.error("خطا در همگام‌سازی کلی:", error);
      notifications.show("خطا در عملیات همگام‌سازی سامانه ها!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
  };
  const onSaveAndClose = async () => {
    await onSave(); // منتظر تکمیل onSave
    setUpdatingSystems && setUpdatingSystems([]);
    onClose(); //
  };
  return (
    <GridToolbarContainer>
      <ActionButtons
        onSave={onSave}
        onSaveAndClose={onSaveAndClose}
        isLoading={
          systemLoading ||
          isDeleteAppUserSystemLoading ||
          isPendingAppUserSystemEdit
        }
      />
    </GridToolbarContainer>
  );
}
